import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-summary-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './summary-grid.component.html',
  styleUrls: ['./summary-grid.component.scss']
})
export class SummaryGridComponent {
  @Input() labels: string[] = [];
  @Input() colors: string[] = [];
  @Input() counts: number[] = [];

  get gridStyle(): Record<string, string> {
    return { 'grid-template-columns': `repeat(${this.labels.length}, 1fr)` };
  }

  displayCount(i: number): string {
    return this.counts[i] ? String(this.counts[i]) : '—';
  }
}
